<template>
  <div>
    <v-list-item
      v-if="item.child == null"
      :to="item.link"
      router
      :class="{
        'pl-13': item.child !== null && !root,
      }"
    >
      <v-list-item-icon v-if="root">
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-group
      v-else
      :value="false"
      no-action
      :sub-group="!root"
      :prepend-icon="renderIcon"
      color="orange"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </template>

      <sub-menu v-for="(item, i) in item.child" :key="i" :item="item" />
    </v-list-group>
  </div>
</template>

<script>
export default {
  name: 'sub-menu',
  props: {
    item: {
      type: Object,
      default: null,
    },
    root: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    renderIcon() {
      return !this.root ? 'mdi-menu-down' : this.item.icon;
    },
  },
};
</script>

<style>
.v-list-group:has(.v-list-item--active)
  > .theme--light.v-list-item.v-list-group__header {
  color: #ff9800 !important;
  caret-color: #ff9800 !important;
}
</style>
